import { Animated, Platform } from 'react-native';

const useActivityStepsCarouselAnimations = (
  cardWidth: number,
  cardGap: number,
  scrollXRef: Animated.Value
) => {
  const getAnimations = (index: number, isStepCompleted: boolean) => {
    const gap = cardGap * index;
    const inputRange = [
      (index - 1) * cardWidth + gap,
      index * cardWidth + gap,
      (index + 1) * cardWidth + gap,
    ];

    const scale = scrollXRef.interpolate({
      inputRange,
      outputRange: [0.9, 1, 0.9],
    });
    const translateY = scrollXRef.interpolate({
      inputRange,
      outputRange: [50, 0, 50],
    });
    const transform = Platform.OS === 'web' ? [{ translateY }] : [{ scale }];

    const toOpacity = isStepCompleted ? 1 : 0.5;
    const opacity = scrollXRef.interpolate({
      inputRange,
      outputRange: [toOpacity, 1, toOpacity],
    });

    return {
      transform,
      opacity,
    };
  };

  return getAnimations;
};

export default useActivityStepsCarouselAnimations;
